import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import {useTheme} from 'styled-components';
import useShow from '../../../../hooks/useShow';
import * as css from './TimetableToolbar.css';
import ChevronFilled from '../../../../assets/icons/ChevronFilled';
import {useTimetableDays} from '../../hooks/useTimetableDays';
import DayPopup from './dayPopup/DayPopup';

function TimetableToolbar() {
    const {t} = useTranslation('timetable');
    const theme = useTheme();
    const dayListShow = useShow();
    const {onPrevDay, onNextDay, currentDateLabel, disablePrev, disableNext} = useTimetableDays();

    const prevStyle = {display: 'flex', transform: theme.rtl ? 'rotate(180deg)' : 'rotate(0deg)'};
    const nextStyle = {display: 'flex', transform: theme.rtl ? 'rotate(0deg)' : 'rotate(180deg)'};
    const downStyle = {display: 'flex', transform: 'rotate(-90deg)'};

    return (
        <css.rightGroup>
            <Button
                variant="subtle"
                size="chip"
                iconStart={<span style={prevStyle}><ChevronFilled /></span>}
                disabled={disablePrev}
                onClick={onPrevDay}
                ariaLabel={t('prevDay')}
            />
            <css.dateBtnWrap onMouseEnter={dayListShow.open} onMouseLeave={dayListShow.close}>
                <Button
                    variant="neutral"
                    size="category"
                    iconEnd={<span style={downStyle}><ChevronFilled /></span>}
                    ariaExpanded={dayListShow.isOpen}
                    ariaHaspopup="listbox"
                >
                    {currentDateLabel}
                </Button>
                <DayPopup show={dayListShow} />
            </css.dateBtnWrap>
            <Button
                variant="subtle"
                size="chip"
                iconStart={<span style={nextStyle}><ChevronFilled /></span>}
                disabled={disableNext}
                onClick={onNextDay}
                ariaLabel={t('nextDay')}
            />
        </css.rightGroup>
    );
}

export default TimetableToolbar;
